var map = {
	"./fab-stablecoin": [
		138,
		138
	],
	"./fab-stablecoin.json": [
		138,
		138
	],
	"./uk-expansion": [
		9232,
		232
	],
	"./uk-expansion.json": [
		9232,
		232
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7957;
module.exports = webpackAsyncContext;